import { CHANNEL_CACHE } from "../misc/Config";

export enum EnumPartnerType {
    NORMAL,
    LOCAL_ASSOCIATION,
    College
}

export default class AdminModel {
    account: string;
    realname: string;
    organizationCode: string;
    type: EnumPartnerType;
    localizedType: string;
    channelsWithName: { id: string, name: string }[];
    inviters: { id: string, name: string }[];

    contactName: string;
    contactPhone: string;
    email: string;
    address: string;
    createAt: number;


    get channels(): string[] {
        return this.channelsWithName.map(_ => _.id);
    }

    currentChannel(): string {
        const cache = localStorage.getItem(CHANNEL_CACHE);
        if (!cache || !this.channels.includes(cache)) {
            localStorage.setItem(CHANNEL_CACHE, this.channels[0]);
            return this.channels[0];
        }
        return cache;
    }

    cacheChannel(channel: string): void {
        localStorage.setItem(CHANNEL_CACHE, channel);
    }

    static modelWithServerData(data: any): AdminModel {
        const model = new AdminModel();
        model.account = data.account;
        model.realname = data.realname;
        model.organizationCode = data.organization_code;
        model.type = data.type;
        model.localizedType = data.localized_type;
        model.channelsWithName = data.channels;
        model.inviters = data.inviters;

        model.contactName = data.contact_name;
        model.contactPhone = data.contact_phone;
        model.email = data.email;
        model.address = data.address;
        model.createAt = data.create_at;

        return model;
    }

}
